'use client'

import RichText from '@/components/RichText'
import { cn } from '@/lib/utils'
import { useState } from 'react'

export default function ProjectTextColumns({ textColumns }) {
	let colWidthClass = 'col-span-full'

	if (textColumns?.length == 3) {
		colWidthClass += ' md:col-span-4'
	} else {
		colWidthClass += ' md:col-span-6'
	}

	return (
		<div
			className={`relative content-block content-block--text-columns w-full px-site-margin mt-[6rem] md:mt-[10rem] mb-[6rem] md:mb-[8rem]`}>
			<div
				className={`relative w-full flex flex-col md:grid md:grid-cols-12 justify-between overflow-clip md:gap-gutter sm:before:content-[''] before:absolute before:block before:w-full before:h-[1px] before:bg-black`}>
				{textColumns?.map((column) => (
					<ProjectTextColumn column={column} key={`column-${column?.heading}`} colWidthClass={colWidthClass} />
				))}
			</div>
		</div>
	)
}

function ProjectTextColumn({ column, colWidthClass }) {
	const [isOpen, setIsOpen] = useState(false)

	return (
		<div
			key={`column-${column?.heading}`}
			className={`${colWidthClass} border-solid border-b sm:border-b-0 first:border-t md:border-none`}>
			<h3
				className="accordion-heading sm:mb-4 md:mb-2 style-h3 py-4 sm:pb-0"
				onClick={() => setIsOpen((prevState) => !prevState)}>
				<div className="flex justify-between gap-6 cursor-pointer md:cursor-auto">
					<span>{column?.heading}</span>
					<span className="sm:hidden">{isOpen ? `–` : `+`}</span>
				</div>
			</h3>

			<div
				className={cn('w-full sm:w-auto grid transition-all duration-300', {
					'grid-rows-[1fr]': isOpen,
					'grid-rows-[0fr]': !isOpen
				})}>
				<div className="overflow-hidden sm:overflow-visible">
					<div className="style-body sm:max-w-[33vw]xxx mt-4 sm:mt-2 md:mt-4 mb-8 sm:mb-6 md:mb-8 pr-6 rich--text-content">
						<RichText content={column?.text} />
					</div>
				</div>
			</div>
		</div>
	)
}
